import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import Formsy from 'formsy-react';
import { autobind } from 'core-decorators';

import { addNewUser } from 'services/api';
import { login } from 'actions';

import LoginWrapper from 'AppComponents/LoginWrapper';
import PageHeader from 'AppComponents/PageHeader';
import Alert from 'AppComponents/Alert';
import { Input } from 'AppComponents/Forms/Formsy';
import SubmitButton from 'AppComponents/SubmitButton';

class UserRegister extends Component {

  static propTypes = {
    isLoggedIn: PropTypes.bool,
    loginError: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    loginRequest: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isLoggedIn: false,
    loginError: null,
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      enableSubmit: false,
      isSubmitting: false,
      serverError: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isLoggedIn) this.context.router.push('/user/account/');
    else if (nextProps.loginError) this.context.router.push('/user/login/');
  }

  @autobind
  handleSubmit(data, resetForm, invalidateForm) {
    this.setState({ isSubmitting: true }, () => {
      addNewUser(data).then(({ error }) => {
        if (error) {
          this.setState({ isSubmitting: false });
          if (typeof error === 'object') {
            this.setState({ serverError: error.detail });
            delete error.detail;
            const errors = {};
            Object.keys(error).forEach((field) => {
              errors[field] = error[field][0];
            });
            invalidateForm(errors);
          } else {
            this.setState({ serverError: 'An unknown error occurred. Please try again.' });
          }
        } else {
          this.props.loginRequest(data.username, data.password);
        }
      });
    });
  }

  render() {
    return (
      <LoginWrapper>

        <Helmet title='Register' />

        <PageHeader title='Create an Account' />

        <Alert type='danger' display={this.state.serverError && true}>
          <strong>Error: </strong>{ this.state.serverError }
        </Alert>

        <Formsy.Form
          className='form with-feedback'
          onValid={() => this.setState({ enableSubmit: true })}
          onInvalid={() => this.setState({ enableSubmit: false })}
          onValidSubmit={this.handleSubmit}
          noValidate
        >

          <Input
            name='username'
            label='Username'
            validations='isAlphanumeric,minLength:6'
            minLength={6}
            validationErrors={{
              isAlphanumeric: 'Must consist only of letters and numbers.',
              minLength: 'Must be at least six characters long.',
            }}
            required
          />

          <Input
            type='email'
            name='email'
            label='Email Address'
            validations='isEmail'
            validationError='Must be a valid email'
            required
          />

          <Input
            type='password'
            name='password'
            label='Password'
            validations={{
              minLength: 6,
              matchRegexp: /^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z]).*$/,
            }}
            validationErrors={{
              minLength: 'Must be at least six characters long.',
              matchRegexp: 'Must contain at least one uppercase letter, one lowercase letter, and one number.', // eslint-disable-line max-len
            }}
            required
          />

          <Input
            type='password'
            name='password2'
            label='Password Confirmation'
            validations='equalsField:password'
            validationError='Passwords must match.'
            required
          />

          <div className='form-footer'>
            <div className='aligned-with-input'>
              <SubmitButton
                label='Register'
                className='pull-right'
                enabled={this.state.enableSubmit}
                isSubmitting={this.state.isSubmitting}
              />
            </div>
          </div>

        </Formsy.Form>

      </LoginWrapper>
    );
  }
}

const mapStateToProps = state => ({
  isLoggedIn: state.auth.isLoggedIn,
  loggingIn: state.auth.loggingIn,
  loginError: state.auth.loginError,
});

const loginRequest = login.request;

export default connect(
  mapStateToProps, {
    loginRequest,
  },
)(UserRegister);



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/UserRegister/index.jsx